import { z } from 'zod'

export const configSchema = z.strictObject({
  rudderstack: z.object({
    writeKey: z.string(),
    dataPlaneUrl: z.string(),
    configUrl: z.string(),
    destSDKBaseURL: z.string(),
    brazeDestinationId: z.string(),
    fullStoryDestinationId: z.string(),
  }),
  braze: z.object({
    apiKey: z.string(),
    apiEndpoint: z.string(),
    enableLogging: z.boolean().optional(),
  }),
  fullStory: z.object({
    debug: z.boolean(),
    devMode: z.boolean(),
    orgId: z.string(),
    host: z.string(),
    script: z.string(),
  }),
  gtm: z
    .object({
      id: z.string(),
      baseUrl: z.string(),
      scriptParams: z.string(),
      scriptPath: z.string(),
    })
    .optional(),
})

export type Config = z.infer<typeof configSchema>
